/** Alphabet rail letters, shared by the catalog route and the browse grid. */
export const LETTER_RAIL_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
//# sourceMappingURL=catalogLetters.js.map